<template>
  <!-- 火车时刻 -->
  <div>
    <div class="comInfo">
      <!-- 中间 -->
      <div class="rowB">
        <div class="body">
          <div class="topTitle">友情链接</div>
          <!-- <div class="littleTitle">
            <span>发布日期：{{info.createDate}}</span>
            <span style="margin-left:5px">编辑者：admin</span>
            <span style="margin-left:5px">来源：{{info.source}}</span>
            <span style="margin-left:5px">点击数：{{info.hits}}</span>
          </div> -->
          <div class="line"></div>
          <div class="leftBody">
            <!-- <div class="" @click="open('https://www.ctrip.com/')">携程旅游</div> -->
            <div class="" @click="open('http://www.9td.cn/')">
              九天达股份
            </div>
            <!-- <div class="" @click="open('https://www.qunar.com/')">去哪儿网</div> -->
          </div>
        </div>
      </div>
      <!-- 右边 -->
      <div class="rowC">
        <div class="layout">
          <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
            <div style="margin-top:1.018vh;">武夷山景区</div>
            <div style="margin-top:1.018vh;">天下难寻</div>
            <div style="margin-top:1.018vh;">Wuyi</div>
            <div>Mountain</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/css/details.css";

export default {
  name: "Company",
  data() {
    return {
      info: {}
    };
  },
  mounted() {},
  methods: {
    open(url) {
      window.open(url, "_blank");
    }
  }
};
</script>

<style scoped>
.leftBody {
  display: flex;
  flex-direction: row;
  color: #000;
  cursor: pointer;
}
.leftBody :hover{
  display: flex;
  flex-direction: row;
  color: #005a51;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/footer/link.vue